module.exports = __webpack_public_path__ + "static/media/tp_small_octupus.7b6f8c84.jpg";